import { TLShape } from 'tldraw'
import { CSSProperties } from 'react'
import { stopEventPropagation, useEditor } from 'tldraw'
import { MessageSquareText, ArrowUpRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/i18n'

const containerStyles: CSSProperties = {
  position: 'absolute',
  pointerEvents: 'all',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const SELECTED_FROM = 'select.idle'

interface customShape {
  props: { graphId?: string; name?: string }
}

const ContextPopup = () => {
  const { t } = useTranslation()
  const editor = useEditor()
  const selectionRotatedPageBounds = editor.getSelectionRotatedPageBounds()
  const showToolbar = editor.isIn(SELECTED_FROM)

  if (!showToolbar || !selectionRotatedPageBounds || !editor) {
    return null
  }

  const pageCoordinates = editor.pageToViewport(
    selectionRotatedPageBounds.point
  )

  const selected = editor.getOnlySelectedShape() as TLShape & customShape

  return (
    selected &&
    selected.props.graphId && (
      <div
        style={{
          ...containerStyles,
          top: pageCoordinates.y - 63,
          left: pageCoordinates.x,
        }}
        onPointerDown={stopEventPropagation}
      >
        <div className="flex flex-col rounded-md shadow-lg bg-white dark:bg-dark-card w-fit h-full items-center">
          <div className="flex w-full h-fit gap-2 items-center justify-between border-b border-1 border-gray-300 dark:border-gray-600 p-2">
            <Button
              variant="link"
              onClick={() => console.log(selected.props.graphId)}
            >
              <ArrowUpRight className="w-4 h-4" />
              {t('board:context_popup.open_document', { defaultValue: 'Open Document' })}
            </Button>
            <Button variant="link">
              <MessageSquareText className="w-4 h-4" />
              {t('board:context_popup.comment', { defaultValue: 'Comment' })}
            </Button>
          </div>
        </div>
      </div>
    )
  )
}

export default ContextPopup
